module.exports = __webpack_public_path__ + "img/playbar_voice_2.902ee743.svg";